import React from 'react';
import { Container, Row, Col, Card, Tab, Nav, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import FalconCardHeader from '../common/FalconCardHeader';
import paths from 'routes/paths';

const BudgetPage = () => {
  const navigate = useNavigate();

  return (
    <Container fluid className="px-3">
      <div className="pb-4">
        {/* Header */}
        <div className="mb-4">
          <Row className="align-items-center">
            <Col>
              <h2 className="mb-2">
                <FontAwesomeIcon icon="dollar-sign" className="me-2 text-primary" />
                Gestión de Presupuestos
              </h2>
              <h5 className="text-700 fw-semi-bold">
                Administra presupuestos publicitarios y aprobaciones
              </h5>
            </Col>
            <Col xs="auto">
              <Button 
                variant="primary" 
                onClick={() => navigate(paths.budgetAccounts)}
                className="me-2"
              >
                <FontAwesomeIcon icon="credit-card" className="me-1" />
                Gestionar Cuentas
              </Button>
            </Col>
          </Row>
        </div>

        <Card className="shadow-sm">
          <FalconCardHeader title="Presupuestos" />
          <Card.Body>
            <div className="text-center py-5">
              <FontAwesomeIcon icon="dollar-sign" size="3x" className="text-muted mb-3" />
              <h4>Módulo de Presupuestos</h4>
              <p className="text-muted">
                Este módulo está en desarrollo. Aquí podrás gestionar presupuestos publicitarios.
              </p>
              <Tab.Container defaultActiveKey="list">
                <Nav variant="tabs" className="justify-content-center mb-3">
                  <Nav.Item>
                    <Nav.Link eventKey="list">
                      <FontAwesomeIcon icon="list" className="me-1" />
                      Ver Presupuestos
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="create">
                      <FontAwesomeIcon icon="plus" className="me-1" />
                      Crear Presupuesto
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="approve">
                      <FontAwesomeIcon icon="check" className="me-1" />
                      Aprobar Presupuestos
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="accounts">
                      <FontAwesomeIcon icon="credit-card" className="me-1" />
                      Gestión de Cuentas
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="list">
                    <div className="text-center">
                      <h6>Lista de Presupuestos</h6>
                      <p className="text-muted">Visualiza todos los presupuestos creados</p>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="create">
                    <div className="text-center">
                      <h6>Crear Nuevo Presupuesto</h6>
                      <p className="text-muted">Formulario para crear presupuestos publicitarios</p>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="approve">
                    <div className="text-center">
                      <h6>Aprobar Presupuestos</h6>
                      <p className="text-muted">Gestiona las aprobaciones de presupuestos</p>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="accounts">
                    <div className="text-center">
                      <h6>Gestión de Cuentas Publicitarias</h6>
                      <p className="text-muted mb-3">Administra las cuentas publicitarias de todos los clientes</p>
                      <Button 
                        variant="primary" 
                        size="lg"
                        onClick={() => navigate(paths.budgetAccounts)}
                      >
                        <FontAwesomeIcon icon="credit-card" className="me-2" />
                        Abrir Gestión de Cuentas
                      </Button>
                      <div className="mt-3">
                        <small className="text-muted">
                          Crear, editar, activar y desactivar cuentas publicitarias
                        </small>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default BudgetPage; 